import { httpClient, ROOT_URL } from '../../App';
import { useState, useCallback, useEffect } from 'react';

const UPDATE_INTERVAL = 5000;

export enum VerificationStatus {
  REQUIRED = 'REQUIRED',
  PENDING = 'PENDING',
  LOW_RISK = 'LOW_RISK',
  MEDIUM_RISK = 'MEDIUM_RISK',
  HIGH_RISK_FIR = 'HIGH_RISK_FIR',
  HIGH_RISK_EDD = 'HIGH_RISK_EDD',
}

export enum OnboardingStatus {
  // PENDING = 'PENDING',
  INVITED = 'INVITED',
  SUBMITTED = 'SUBMITTED',
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
  BLOCKED = 'BLOCKED',
  RESTRICTED = 'RESTRICTED',
}


export interface WorldcheckVerification {
  status: VerificationStatus;
  companyCaseId?: string;
  individualCaseId?: string;
  lastStatus?: string;
  regNo?: string;
  companyCountry?: string;
  directorName?: string;
}

export const useWorldCheckVerification = () => {
  const [data, setData] = useState<WorldcheckVerification>();
  const [isLoading, setIsLoading] = useState(false);

  const fetch = useCallback(async (): Promise<void> => {
    setIsLoading(true);

    try {
      const result = await httpClient.get(`${ROOT_URL}/api/v1/worldCheck`);
      if (result.status === 200) {
        setData(result.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    (async () => await fetch())();
  }, [fetch]);

  useEffect(() => {
    if (data?.status === VerificationStatus.PENDING) {
      const interval = setInterval(async () => {
        await fetch();
      }, UPDATE_INTERVAL);

      return () => {
        clearInterval(interval);
      };
    }
  }, [data, fetch]);

  return { data, fetch, isLoading };
};
